module.exports = __webpack_public_path__ + "media/login-bg-3.945cbe62.mp4";